export var TaskType;
(function (TaskType) {
    TaskType["VERIFICATION"] = "VERIFICATION";
    TaskType["TRANSFER"] = "TRANSFER";
    TaskType["REFILL"] = "REFILL";
    TaskType["GENERAL"] = "GENERAL";
})(TaskType || (TaskType = {}));
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus["PENDING"] = "PENDING";
    TaskStatus["IN_PROGRESS"] = "IN_PROGRESS";
    TaskStatus["COMPLETED"] = "COMPLETED";
    TaskStatus["CANCELLED"] = "CANCELLED";
})(TaskStatus || (TaskStatus = {}));
